import { useAppDispatch, useAppSelector } from 'store/hooks';

import { analyticsUserType, GTM_EVENT_TYPES, Q_INTERACTION_TYPES, sendAnalytics } from 'analytics';
import { sendAuditEvent } from 'utils';
import { redirectToClaimsPortalAction } from 'actions/redirectToClaimsPortalAction';
import { PageNavigation } from 'components/layout/navigation/pageNavigation';
import type { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';
import { Button } from 'components/shared/button';
import { PATH } from 'interfaces/pathTypes';
import { AUDIT_TYPE } from 'interfaces/auditTypes';
import { Title } from 'components/layout/header/title';

import './claims.scss';

export const Claims = ({ selectedPolicy }: HpChildComponentProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const authentication = useAppSelector((state) => state.authentication);
  const { isAgent } = authentication;

  const handleClick = () => {
    const { policyDetailsId, policyNumber, historyId } = selectedPolicy;
    sendAuditEvent({
      policyDetailsId,
      policyNumber,
      historyId,
      activityId: AUDIT_TYPE.START_CLAIM
    });
    sendAnalytics({
      event: GTM_EVENT_TYPES.QINTERACTION,
      detail: {
        qinteraction_type: Q_INTERACTION_TYPES.PRIMARY_ACTION_BUTTON_CLICK,
        qinteraction_locator: 'dcj_start_cta',
        qinteraction_value: 'submit_claim',
        usertype: analyticsUserType(isAgent)
      }
    });
    dispatch(
      redirectToClaimsPortalAction({
        emailAddress: selectedPolicy.email,
        postcode: selectedPolicy.correspondencePostcode
      })
    );
  };

  return (
    <>
      <Title title="MAKE A HOME INSURANCE CLAIM" icon="broken-circle" id="claims" />
      <div className="claims-container">
        <h2>BEFORE YOU CLAIM</h2>
        <p>
          Before you submit a claim, it&apos;s important to understand the level of cover you have and how your policy
          might be affected. You can find out more about your policy coverage by continuing below.
        </p>
        <Button handleClick={handleClick} text="SUBMIT A CLAIM" className="submit-button" id="open-portal" />
      </div>
      <PageNavigation page={PATH.CLAIMS} />
    </>
  );
};
